<template>
	<div>
		<div class="d-flex flex-wrap justify-space-between mb-4">
			<h2>Experience</h2>
			<div>
				<v-btn color="primary" @click="dialogSelectAddMode.show = true">Add Experience</v-btn>
			</div>
		</div>
		<div class="d-flex flex-wrap justify-space-around align-stretch">
			<v-hover
				v-for="(entity, idxEntity) in entityList"
				:key="idxEntity"
				v-slot:default="{ hover }"
			>
				<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
					<v-card-text>
						<v-btn
							:color="entity.status ? 'success' : 'warning'"
							x-small
							dense
							outlined
							>{{ entity.status ? "Published" : " Draft" }}</v-btn
						>
						<v-btn
							style="margin-left: 5px;"
							v-if="entity.template == true"
							:color="'warning'"
							x-small
							dense
							outlined
							>Template</v-btn
						>
					</v-card-text>
					<v-img
						style="background-color: rgba(0, 0, 0, 0.05)"
						aspect-ratio="1.7"
						contain
						:src="$root.asset(entity.logo)"
						height="200px"
					></v-img>
					<v-card-title>{{ entity.name }}</v-card-title>
					<v-card-subtitle v-if="entity.dataMap.ongoing">
						Ongoing
					</v-card-subtitle>
					<v-card-subtitle v-else>
						{{
							entity.transitMap.startDateText +
							" - " +
							entity.transitMap.endDateText
						}}
					</v-card-subtitle>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									v-bind="attrs"
									v-on="on"
									@click="navigateTo(entity)"
								>
									<v-icon>mdi-home-edit</v-icon>
								</v-btn>
							</template>
							<span>Configure Experience</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									v-bind="attrs"
									v-on="on"
									@click="showEdit(entity)"
								>
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
							</template>
							<span>Edit</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									v-bind="attrs"
									v-on="on"
									@click="showMenu(entity)"
								>
									<v-icon>mdi-menu</v-icon>
								</v-btn>
							</template>
							<span>Menu Navigation</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="duplicateExperience(entity.id)">
									<v-icon>mdi-content-duplicate</v-icon>
								</v-btn>
							</template>
							<span>Duplicate Experience</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									v-bind="attrs"
									v-on="on"
									@click="deleteExperience(entity.id)"
								>
									<v-icon color="red">mdi-delete</v-icon>
								</v-btn>
							</template>
							<span>Delete</span>
						</v-tooltip>
					</v-card-actions>
				</v-card>
			</v-hover>
		</div>
		<v-dialog v-model="dialogSelectAddMode.show" max-width="500">
			<v-card>
				<v-card-title>Select Add Mode</v-card-title>

				<v-form class="px-5">
					<v-select v-model="dialogSelectAddMode.selected" :items="dialogSelectAddMode.addMode" label="Select Add Mode" solo return-object> </v-select>
				</v-form>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogSelectAddMode.show = false">Cancel</v-btn>
					<v-btn color="primary" @click="dialogSelectAddMode.selected === 'New' ? showAdd() : showAddByTemplate()">Confirm</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogAdd"
			persistent
			no-click-animation
			fullscreen
			transition="dialog-bottom-transition"
			:retain-focus="false"
		>
			<v-card tile>
				<v-card-title class="headline">
					Add Experience
					<v-spacer></v-spacer>
					<v-btn icon @click="closeAdd()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-form
						ref="formAdd"
						v-model="valid"
						@submit.prevent="addExperience()"
					>
						<v-row class="mt-4">
							<v-col cols="12" sm="6">
								<v-text-field
									v-model="entity.name"
									label="Name"
									:rules="[(v) => !!v || 'Name is required']"
									prepend-icon="mdi-calendar-text"
									@input="
										entity.slug = entity.name
											? entity.name
													.toLowerCase()
													.replace(/ /g, '')
											: null
									"
									dense
									required
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field
									v-model="entity.slug"
									label="URL"
									:hint="
										host +
										'/#/' +
										$store.state.principal.tenantSlug +
										'/' +
										entity.slug
									"
									:rules="[(v) => !!v || 'URL is required', (v) => !v.includes(' ') || 'URL must not contain any spaces']"
									prepend-icon="mdi-web"
									dense
									required
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-textarea
									v-model="entity.description"
									label="Description"
									dense
									outlined
									prepend-icon="mdi-calendar-text"
								></v-textarea>
							</v-col>
							<v-col cols="12" sm="6">
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="!entity.dataMap.ongoing"
							>
								<v-menu
									ref="startDate"
									v-model="isShowAddStartDate"
									:close-on-content-click="false"
									:return-value.sync="
										entity.transitMap.startDate
									"
									transition="scale-transition"
									offset-y
									max-width="290px"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="
												entity.transitMap.startDate
											"
											label="Start Date"
											:rules="[
												(v) =>
													!!v ||
													'Start Date is required',
											]"
											prepend-icon="mdi-calendar-clock"
											v-bind="attrs"
											v-on="on"
											dense
											autocomplete="off"
											@click="resetTime"
										></v-text-field>
									</template>
									<v-date-picker
										:min="
											new Date()
												.toISOString()
												.substr(0, 10)
										"
										v-model="entity.transitMap.startDate"
										@input="
											entity.transitMap.startDate = changeDatetime(
												entity.transitMap.startDate
											)
										"
										color="primary"
										no-title
									>
										<div
											class="d-flex flex-column"
											style="width: 100%"
										>
											<div
												class="d-flex flex-row align-space-arround"
											>
												<span>Time</span>
												<v-select
													v-model="hour"
													:items="
														Array(24)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entity.transitMap.startDate = changeDatetime(
															entity.transitMap
																.startDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template> </v-select
												>:
												<v-select
													v-model="minute"
													:items="
														Array(60)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entity.transitMap.startDate = changeDatetime(
															entity.transitMap
																.startDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template> </v-select
												>:
												<v-select
													v-model="second"
													:items="
														Array(60)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entity.transitMap.startDate = changeDatetime(
															entity.transitMap
																.startDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template>
												</v-select>
											</div>
											<v-divider></v-divider>
											<div class="d-flex justify-end">
												<v-btn
													text
													color="primary"
													@click="
														isShowAddStartDate = false
													"
													>Cancel</v-btn
												>
												<v-btn
													text
													color="primary"
													@click="
														$refs.startDate.save(
															(entity.transitMap.startDate = changeDatetime(
																entity
																	.transitMap
																	.startDate
															))
														)
													"
													>OK</v-btn
												>
											</div>
										</div>
									</v-date-picker>
								</v-menu>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="!entity.dataMap.ongoing"
							>
								<v-menu
									ref="endDate"
									v-model="isShowAddEndDate"
									:close-on-content-click="false"
									:return-value.sync="
										entity.transitMap.endDate
									"
									transition="scale-transition"
									offset-y
									max-width="290px"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="entity.transitMap.endDate"
											label="End Date"
											:rules="[
												(v) =>
													!!v ||
													'End Date is required',
											]"
											prepend-icon="mdi-calendar-clock"
											v-bind="attrs"
											v-on="on"
											dense
											autocomplete="off"
											@click="resetTime"
										></v-text-field>
									</template>
									<v-date-picker
										:min="entity.transitMap.startDate ? entity.transitMap.startDate :
											new Date().toISOString().substr(0, 10)
										"
										v-model="entity.transitMap.endDate"
										@input="
											entity.transitMap.endDate = changeDatetime(
												entity.transitMap.endDate
											)
										"
										color="primary"
										no-title
									>
										<div
											class="d-flex flex-column"
											style="width: 100%"
										>
											<div
												class="d-flex flex-row align-space-arround"
											>
												<span>Time</span>
												<v-select
													v-model="hour"
													:items="
														Array(24)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entity.transitMap.endDate = changeDatetime(
															entity.transitMap
																.endDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template> </v-select
												>:
												<v-select
													v-model="minute"
													:items="
														Array(60)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entity.transitMap.endDate = changeDatetime(
															entity.transitMap
																.endDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template> </v-select
												>:
												<v-select
													v-model="second"
													:items="
														Array(60)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entity.transitMap.endDate = changeDatetime(
															entity.transitMap
																.endDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template>
												</v-select>
											</div>
											<v-divider></v-divider>
											<div class="d-flex justify-end">
												<v-btn
													text
													color="primary"
													@click="
														isShowAddEndDate = false
													"
													>Cancel</v-btn
												>
												<v-btn
													text
													color="primary"
													@click="
														$refs.endDate.save(
															(entity.transitMap.endDate = changeDatetime(
																entity
																	.transitMap
																	.endDate
															))
														)
													"
													>OK</v-btn
												>
											</div>
										</div>
									</v-date-picker>
								</v-menu>
							</v-col>
							<v-col
								cols="12"
								sm="2"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-select
									v-model="logoType"
									:items="['Upload', 'URL']"
									label="Logo Type"
									hint="Choose how to fill the logo"
									:prepend-icon="
										logoType === 'Upload'
											? 'mdi-upload'
											: 'mdi-file-cloud'
									"
									persistent-hint
									dense
								></v-select>
							</v-col>
							<v-col
								cols="12"
								sm="4"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-file-input
									v-if="logoType === 'Upload'"
									v-model="attachment1"
									accept="image/png, image/jpeg, image/jpg"
									label="Select your logo"
									hint="It’s recommended to use image with resolution approximately 215 x 90 pixels."
									persistent-hint
									prepend-icon="mdi-image"
									:show-size="1000"
									dense
								>
									<template
										v-slot:selection="{ text }"
										:default="entity.logo"
									>
										<v-chip
											color="primary"
											dark
											label
											small
											>{{ text }}</v-chip
										>
									</template>
								</v-file-input>
								<v-text-field
									v-else
									v-model="entity.logo"
									prepend-icon="mdi-image"
									label="Select your logo"
									placeholder="Logo Url"
									hint="It’s recommended to use image with resolution approximately 215 x 90 pixels."
									persistent-hint
									dense
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="2"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-select
									v-model="bannerType"
									:items="['Upload', 'URL']"
									label="Banner Type"
									hint="Choose how to fill the banner"
									:prepend-icon="
										bannerType === 'Upload'
											? 'mdi-upload'
											: 'mdi-file-cloud'
									"
									persistent-hint
									dense
								></v-select>
							</v-col>
							<v-col
								cols="12"
								sm="4"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-file-input
									v-if="bannerType === 'Upload'"
									v-model="attachment2"
									accept="image/png, image/jpeg, image/jpg"
									label="Select your banner"
									hint="It’s recommended to use image with resolution approximately 400 x 60 pixels."
									persistent-hint
									prepend-icon="mdi-image"
									:show-size="1000"
									dense
								>
									<template
										v-slot:selection="{ text }"
										:default="entity.banner"
									>
										<v-chip
											color="primary"
											dark
											label
											small
											>{{ text }}</v-chip
										>
									</template>
									<template v-slot:append>
										<v-tooltip top>
											<template
												v-slot:activator="{ on, attrs }"
											>
												<v-icon
													v-bind="attrs"
													v-on="on"
													color="grey lighten-1"
													>mdi-information-outline</v-icon
												>
											</template>
											<span
												>It will be used as a banner at
												the middle top of your
												experience</span
											>
										</v-tooltip>
									</template>
								</v-file-input>
								<v-text-field
									v-else
									v-model="entity.banner"
									prepend-icon="mdi-image"
									label="Select your banner"
									placeholder="Banner Url"
									hint="It’s recommended to use image with resolution approximately 400 x 60 pixels."
									persistent-hint
									dense
								>
									<template v-slot:append>
										<v-tooltip top>
											<template
												v-slot:activator="{ on, attrs }"
											>
												<v-icon
													v-bind="attrs"
													v-on="on"
													color="grey lighten-1"
													>mdi-information-outline</v-icon
												>
											</template>
											<span
												>It will be used as a banner at
												the middle top of your
												experience</span
											>
										</v-tooltip>
									</template>
								</v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="8"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-row>
									<v-col cols="8">
										<v-autocomplete
											v-model="boothBackgroundTagFilter"
											:items="boothBackgroundTagList"
											chips
											small-chips
											deletable-chips
											label="Filter by tags"
											multiple
											solo
											dense
										></v-autocomplete>
									</v-col>
									<div style="display:flex;flex-direction:row;margin-top:13px;">
										<v-btn style="margin-right:10px" @click="filterBoothBackground" color="primary">filter</v-btn>
										<v-btn @click="resetBoothBackground" color="primary">Reset</v-btn>
									</div>
								</v-row>
								<v-carousel hide-delimiters class="top">
									<v-carousel-item v-for="(item, i) in boothBackgroundList" :key="i" eager>
										<v-img :src="$root.asset(item.background)" contain eager>
											<v-btn v-if="item.id == selectedBoothBackground" color="blue">Selected Booth Background</v-btn>
											<v-btn v-else @click="selectBoothBackground(item)">Select This Booth Background</v-btn>
										</v-img>
									</v-carousel-item>
								</v-carousel>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="!entity.dataMap.ongoing"
							>
								<v-autocomplete
									v-model="entity.timeZone"
									:rules="[
										(v) => !!v || 'Time Zone is required',
									]"
									:items="timeZones"
									label="Time Zone"
									prepend-icon="mdi-map-clock"
									dense
								></v-autocomplete>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-text-field
									v-model="entity.dataMap.twitterId"
									prepend-icon="mdi-twitter"
									label="Twitter Id"
									hint="Twitter username without @"
									persistent-hint
									dense
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-text-field
									v-model="entity.masterPassword"
									prepend-icon="mdi-fingerprint"
									label="Master Password"
									hint="Login as any user in this experience using this master password"
									persistent-hint
									dense
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="
									this.$store.state.principal.type ===
									'Clinic'
								"
							>
								<v-checkbox
									v-model="entity.dataMap.ongoing"
									:prepend-icon="
										entity.dataMap.ongoing
											? 'mdi-timer-off-outline'
											: 'mdi-timer-outline'
									"
									label="Ongoing"
									class="mt-0"
									dense
								></v-checkbox>
							</v-col>
							<v-col cols="12" sm="6">
								<v-switch
									v-model="entity.status"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entity.status ? 'Active' : 'Inactive'
									"
									class="mt-0"
									dense
								></v-switch>
							</v-col>
							<v-col cols="12" sm="6">
								<v-switch
									v-model="entity.dataMap.showHeader"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entity.dataMap.showHeader ? 'Show Header' : 'Hide Header'
									"
									class="mt-0"
									dense
									hint=""
									persistent-hint
								></v-switch>
							</v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                v-if="$store.state.principal.type != 'Clinic'"
                            >
								<v-switch
									v-model="entity.dataMap.useMobileNavigation"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entity.dataMap.useMobileNavigation
                                            ? 'Mobile Navigation'
                                            : 'Default Navigation'
									"
									class="mt-0"
									dense
									hint=""
									persistent-hint
								></v-switch>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="$store.state.principal.type != 'Clinic'"
							>
								<v-switch
									v-model="entity.dataMap.showBoothRepsOnly"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entity.dataMap.showBoothRepsOnly ? 'Active' : 'Inactive'
									"
									class="mt-0"
									dense
									hint="Attendees only see booth reps online (for booth chat)"
									persistent-hint
								></v-switch>
							</v-col>
							<v-col cols="12" sm="6">
								<v-switch
									v-model="entity.dataMap.fitToHeight"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entity.dataMap.fitToHeight ? 'Enabled' : 'Disabled'
									"
									class="mt-0"
									dense
									hint="Adjust the background fit to the screen"
									persistent-hint
								></v-switch>
							</v-col>
							<v-col cols="12" sm="6">
								<v-switch
									v-model="entity.layerMode"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entity.layerMode == true ? 'Enabled' : 'Disabled'
									"
									class="mt-0"
									dense
									hint="Enable layer mode"
									persistent-hint
								></v-switch>
							</v-col>
							<v-col cols="12" sm="6" v-if="this.isUserAdmin == true">
								<v-switch
									v-model="entity.template"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entity.template == true ? 'Active' : 'Inactive'
									"
									class="mt-0"
									dense
									hint="Event Template"
									persistent-hint
								></v-switch>
							</v-col><v-col
								cols="12"
								sm="6"
								v-if="entity.template"
							>
							</v-col>
							<v-col
								cols="12"
								sm="2"
								v-if="entity.template"
							>
								<v-select
									v-model="imageTemplateType"
									:items="['Upload', 'URL']"
									label="Image Template Type"
									hint="Choose how to fill the Image Template"
									:prepend-icon="
										imageTemplateType === 'Upload'
											? 'mdi-upload'
											: 'mdi-file-cloud'
									"
									persistent-hint
									dense
								></v-select>
							</v-col>
							<v-col
								cols="12"
								sm="4"
								v-if="entity.template"
							>
								<v-file-input
									v-if="imageTemplateType === 'Upload'"
									v-model="attachment4"
									accept="image/png, image/jpeg, image/jpg"
									label="Select your Image Template"
									hint="It’s recommended to use image with resolution approximately 400 x 60 pixels."
									persistent-hint
									prepend-icon="mdi-image"
									:show-size="1000"
									dense
								>
									<template
										v-slot:selection="{ text }"
										:default="entity.imageTemplate"
									>
										<v-chip
											color="primary"
											dark
											label
											small
											>{{ text }}</v-chip
										>
									</template>
								</v-file-input>
								<v-text-field
									v-else
									v-model="entity.imageTemplate"
									prepend-icon="mdi-image"
									label="Select your image template"
									placeholder="Image Template Url"
									hint="It’s recommended to use image with resolution approximately 400 x 60 pixels."
									persistent-hint
									dense
								>
								</v-text-field>
							</v-col>
						</v-row>
						<div>
							Error Notification :
							<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="initTextEditor" v-model="entity.errorMsg"/>
						</div>
						<div class="d-flex justify-end">
							a
							<v-btn
								:disabled="!valid"
								type="submit"
								color="primary darken-1"
								depressed
								tile
								>Save</v-btn
							>
						</div>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogAddByTemplate.show" :retain-focus="false" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card style="overflow-x: auto">
				<v-card-title class="headline">
					Choose one of the template below
					<v-spacer></v-spacer>
					<v-btn icon @click="closeAddByTemplate">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4 mb-4"></v-divider>

				<v-col icon cols="4">
					<v-text-field label="Quick Search" v-model="dialogAddByTemplate.search" append-icon="mdi-magnify"></v-text-field>
				</v-col>

				<div class="d-flex flex-wrap justify-space-around align-stretch">
					<v-hover v-for="(template, index) in filterExperienceTemplateByName" :key="index" v-slot:default="{ hover }">
						<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5" @click="duplicateExperienceTemplate(template.id)">
							<div id="structure-view" style="display: block">
								<div class="entry-view">
									<v-img
										style="background-color: rgba(0, 0, 0, 0.05)"
										contain
										:src="$root.asset(template.imageTemplate)"
										max-height="200"
										min-height="200"
									></v-img>
									<v-card-title class="justify-center">{{ template.name }}</v-card-title>
									<v-card-text v-html="parseHtml(template.description)"></v-card-text>
								</div>
							</div>
						</v-card>
					</v-hover>
				</div>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="dialogEdit"
			persistent
			no-click-animation
			fullscreen
			transition="dialog-bottom-transition"
			:retain-focus="false"
		>
			<v-card tile>
				<v-card-title class="headline">
					Edit Experience
					<v-spacer></v-spacer>
					<v-btn icon @click="closeEdit()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-form
						ref="formEdit"
						v-model="valid"
						@submit.prevent="editExperience()"
					>
						<v-row class="mt-4">
							<v-col cols="12" sm="6">
								<v-text-field
									v-model="entityEdit.name"
									label="Name"
									:rules="[(v) => !!v || 'Name is required']"
									prepend-icon="mdi-calendar-text"
									@input="
										entityEdit.slug = entityEdit.name
											? entityEdit.name
													.toLowerCase()
													.replace(/ /g, '')
											: null
									"
									dense
									required
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field
									v-model="entityEdit.slug"
									label="URL"
									:hint="
										host +
										'/#/' +
										$store.state.principal.tenantSlug +
										'/' +
										entityEdit.slug
									"
									:rules="[(v) => !!v || 'URL is required', (v) => !v.includes(' ') || 'URL must not contain any spaces']"
									prepend-icon="mdi-web"
									dense
									required
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-textarea
									v-model="entityEdit.description"
									label="Description"
									dense
									outlined
									prepend-icon="mdi-calendar-text"
								></v-textarea>
							</v-col>
							<v-col cols="12" sm="6">
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="!entityEdit.dataMap.ongoing"
							>
								<v-menu
									ref="startDateEdit"
									v-model="isShowEditStartDate"
									:close-on-content-click="false"
									:return-value.sync="
										entityEdit.transitMap.startDate
									"
									transition="scale-transition"
									offset-y
									max-width="290px"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="
												entityEdit.transitMap.startDate
											"
											label="Start Date"
											:rules="[
												(v) =>
													!!v ||
													'Start Date is required',
											]"
											prepend-icon="mdi-calendar-clock"
											v-bind="attrs"
											v-on="on"
											dense
											autocomplete="off"
											@click="resetTime"
										></v-text-field>
									</template>
									<v-date-picker
										:min="
											new Date()
												.toISOString()
												.substr(0, 10)
										"
										v-model="
											entityEdit.transitMap.startDate
										"
										@input="
											entityEdit.transitMap.startDate = changeDatetime(
												entityEdit.transitMap.startDate
											)
										"
										color="primary"
										no-title
									>
										<div
											class="d-flex flex-column"
											style="width: 100%"
										>
											<div
												class="d-flex flex-row align-space-arround"
											>
												<span>Time</span>
												<v-select
													v-model="hour"
													:items="
														Array(24)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entityEdit.transitMap.startDate = changeDatetime(
															entityEdit
																.transitMap
																.startDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template> </v-select
												>:
												<v-select
													v-model="minute"
													:items="
														Array(60)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entityEdit.transitMap.startDate = changeDatetime(
															entityEdit
																.transitMap
																.startDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template> </v-select
												>:
												<v-select
													v-model="second"
													:items="
														Array(60)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entityEdit.transitMap.startDate = changeDatetime(
															entityEdit
																.transitMap
																.startDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template>
												</v-select>
											</div>
											<v-divider></v-divider>
											<div class="d-flex justify-end">
												<v-btn
													text
													color="primary"
													@click="
														isShowEditStartDate = false
													"
													>Cancel</v-btn
												>
												<v-btn
													text
													color="primary"
													@click="
														$refs.startDateEdit.save(
															(entityEdit.transitMap.startDate = changeDatetime(
																entityEdit
																	.transitMap
																	.startDate
															))
														)
													"
													>OK</v-btn
												>
											</div>
										</div>
									</v-date-picker>
								</v-menu>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="!entityEdit.dataMap.ongoing"
							>
								<v-menu
									ref="endDateEdit"
									v-model="isShowEditEndDate"
									:close-on-content-click="false"
									:return-value.sync="
										entityEdit.transitMap.endDate
									"
									transition="scale-transition"
									offset-y
									max-width="290px"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="
												entityEdit.transitMap.endDate
											"
											label="End Date"
											:rules="[
												(v) =>
													!!v ||
													'End Date is required',
											]"
											prepend-icon="mdi-calendar-clock"
											v-bind="attrs"
											v-on="on"
											dense
											autocomplete="off"
											@click="resetTime"
										></v-text-field>
									</template>
									<v-date-picker
										:min="entityEdit.transitMap.startDate ? entityEdit.transitMap.startDate :
											new Date().toISOString().substr(0, 10)
										"
										v-model="entityEdit.transitMap.endDate"
										@input="
											entityEdit.transitMap.endDate = changeDatetime(
												entityEdit.transitMap.endDate
											)
										"
										color="primary"
										no-title
									>
										<div
											class="d-flex flex-column"
											style="width: 100%"
										>
											<div
												class="d-flex flex-row align-space-arround"
											>
												<span>Time</span>
												<v-select
													v-model="hour"
													:items="
														Array(24)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entityEdit.transitMap.endDate = changeDatetime(
															entityEdit
																.transitMap
																.endDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template> </v-select
												>:
												<v-select
													v-model="minute"
													:items="
														Array(60)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entityEdit.transitMap.endDate = changeDatetime(
															entityEdit
																.transitMap
																.endDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template> </v-select
												>:
												<v-select
													v-model="second"
													:items="
														Array(60)
															.fill()
															.map((x, i) =>
																(
																	'' + i
																).padStart(
																	2,
																	'0'
																)
															)
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="
														entityEdit.transitMap.endDate = changeDatetime(
															entityEdit
																.transitMap
																.endDate
														)
													"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span
															v-if="item"
															class="d-flex justify-center pl-6"
															style="width: 100%"
															>{{ item }}</span
														>
													</template>
												</v-select>
											</div>
											<v-divider></v-divider>
											<div class="d-flex justify-end">
												<v-btn
													text
													color="primary"
													@click="
														isShowEditEndDate = false
													"
													>Cancel</v-btn
												>
												<v-btn
													text
													color="primary"
													@click="
														$refs.endDateEdit.save(
															(entityEdit.transitMap.endDate = changeDatetime(
																entityEdit
																	.transitMap
																	.endDate
															))
														)
													"
													>OK</v-btn
												>
											</div>
										</div>
									</v-date-picker>
								</v-menu>
							</v-col>
							<v-col
								cols="12"
								sm="2"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-select
									v-model="logoType"
									:items="['Upload', 'URL']"
									label="Logo Type"
									hint="Choose how to fill the logo"
									:prepend-icon="
										logoType === 'Upload'
											? 'mdi-upload'
											: 'mdi-file-cloud'
									"
									persistent-hint
									dense
								></v-select>
							</v-col>
							<v-col
								cols="12"
								sm="4"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-file-input
									v-if="logoType === 'Upload'"
									v-model="attachment1"
									accept="image/png, image/jpeg, image/jpg"
									label="Select your logo"
									hint="It’s recommended to use image with resolution approximately 215 x 90 pixels."
									persistent-hint
									prepend-icon="mdi-image"
									:show-size="1000"
									dense
								>
									<template
										v-slot:selection="{ text }"
										:default="entityEdit.logo"
									>
										<v-chip
											color="primary"
											dark
											label
											small
											>{{ text }}</v-chip
										>
									</template>
								</v-file-input>
								<v-text-field
									v-else
									v-model="entityEdit.logo"
									prepend-icon="mdi-image"
									label="Select your logo"
									placeholder="Logo Url"
									hint="It’s recommended to use image with resolution approximately 215 x 90 pixels."
									persistent-hint
									dense
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="2"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-select
									v-model="bannerType"
									:items="['Upload', 'URL']"
									label="Banner Type"
									hint="Choose how to fill the banner"
									:prepend-icon="
										bannerType === 'Upload'
											? 'mdi-upload'
											: 'mdi-file-cloud'
									"
									persistent-hint
									dense
								></v-select>
							</v-col>
							<v-col
								cols="12"
								sm="4"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-file-input
									v-if="bannerType === 'Upload'"
									v-model="attachment2"
									accept="image/png, image/jpeg, image/jpg"
									label="Select your banner"
									hint="It’s recommended to use image with resolution approximately 400 x 60 pixels."
									persistent-hint
									prepend-icon="mdi-image"
									:show-size="1000"
									dense
								>
									<template
										v-slot:selection="{ text }"
										:default="entityEdit.banner"
									>
										<v-chip
											color="primary"
											dark
											label
											small
											>{{ text }}</v-chip
										>
									</template>
									<template v-slot:append>
										<v-tooltip top>
											<template
												v-slot:activator="{ on, attrs }"
											>
												<v-icon
													v-bind="attrs"
													v-on="on"
													color="grey lighten-1"
													>mdi-information-outline</v-icon
												>
											</template>
											<span
												>It will be used as a banner at
												the middle top of your
												experience</span
											>
										</v-tooltip>
									</template>
								</v-file-input>
								<v-text-field
									v-else
									v-model="entityEdit.banner"
									prepend-icon="mdi-image"
									label="Select your banner"
									placeholder="Banner Url"
									hint="It’s recommended to use image with resolution approximately 400 x 60 pixels."
									persistent-hint
									dense
								>
									<template v-slot:append>
										<v-tooltip top>
											<template
												v-slot:activator="{ on, attrs }"
											>
												<v-icon
													v-bind="attrs"
													v-on="on"
													color="grey lighten-1"
													>mdi-information-outline</v-icon
												>
											</template>
											<span
												>It will be used as a banner at
												the middle top of your
												experience</span
											>
										</v-tooltip>
									</template>
								</v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="8"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<div v-if="!showBoothBackgroundLibrary">
										<v-btn color="primary" @click="changeBoothBackground">Change Your Booth Background Template</v-btn>
										<h2 style="margin-top:20px">Selected Template : </h2>
										<v-img :src="$root.asset(selectedBoothBackgroundImage)" eager></v-img>
								</div>
								<div v-else>
									<v-row>
										<v-col cols="8">
											<v-autocomplete
												v-model="boothBackgroundTagFilter"
												:items="boothBackgroundTagList"
												chips
												small-chips
												deletable-chips
												label="Filter by tags"
												multiple
												solo
												dense
											></v-autocomplete>
										</v-col>
										<div style="display:flex;flex-direction:row;margin-top:13px;">
											<v-btn style="margin-right:10px" @click="filterBoothBackground" color="primary">filter</v-btn>
											<v-btn @click="resetBoothBackground" color="primary">Reset</v-btn>
										</div>
									</v-row>
									<v-carousel hide-delimiters class="top">
										<v-carousel-item v-for="(item, i) in boothBackgroundList" :key="i" eager>
											<v-img :src="$root.asset(item.background)" contain eager>
												<v-btn v-if="item.id == selectedBoothBackground" color="blue">Selected Booth Background</v-btn>
												<v-btn v-else @click="selectBoothBackground(item)">Select This Booth Background</v-btn>
											</v-img>
										</v-carousel-item>
									</v-carousel>
									<div class="d-flex justify-end top">
										<v-btn color="primary" v-if="showBoothBackgroundLibrary" @click="showBoothBackgroundLibrary=false">Cancel</v-btn>
									</div>
								</div>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="!entityEdit.dataMap.ongoing"
							>
								<v-autocomplete
									v-model="entityEdit.timeZone"
									:rules="[
										(v) => !!v || 'Time Zone is required',
									]"
									:items="timeZones"
									label="Time Zone"
									prepend-icon="mdi-map-clock"
									dense
								></v-autocomplete>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-text-field
									v-model="entityEdit.dataMap.twitterId"
									prepend-icon="mdi-twitter"
									label="Twitter Id"
									hint="Twitter username without @"
									persistent-hint
									dense
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="
									this.$store.state.principal.type != 'Clinic'
								"
							>
								<v-text-field
									v-model="entityEdit.masterPassword"
									prepend-icon="mdi-fingerprint"
									label="Master Password"
									hint="Login as any user in this experience using this master password"
									persistent-hint
									dense
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="
									this.$store.state.principal.type ===
									'Clinic'
								"
							>
								<v-checkbox
									v-model="entityEdit.dataMap.ongoing"
									:prepend-icon="
										entityEdit.dataMap.ongoing
											? 'mdi-timer-off-outline'
											: 'mdi-timer-outline'
									"
									label="Ongoing"
									class="mt-0"
									dense
								></v-checkbox>
							</v-col>
							<v-col cols="12" sm="6">
								<v-switch
									v-model="entityEdit.status"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entityEdit.status ? 'Active' : 'Inactive'
									"
									class="mt-0"
									dense
								></v-switch>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								v-if="$store.state.principal.type != 'Clinic'"
							>
								<v-switch
									v-model="entityEdit.dataMap.showHeader"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entityEdit.dataMap.showHeader ? 'Show Header' : 'Hide Header'
									"
									class="mt-0"
									dense
									hint=""
									persistent-hint
								></v-switch>
							</v-col>
                            <v-col
								cols="12"
								sm="6"
								v-if="$store.state.principal.type != 'Clinic'"
							>
								<v-switch
									v-model="entityEdit.dataMap.useMobileNavigation"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entityEdit.dataMap.useMobileNavigation ? 'Mobile Navigation' : 'Default Navigation'
									"
									class="mt-0"
									dense
									hint=""
									persistent-hint
                                    @change="testMethod(entityEdit.dataMap)"
								></v-switch>
							</v-col>
							<v-col cols="12" sm="6" v-if="$store.state.principal.type != 'Clinic'">
								<v-switch
									v-model="entityEdit.dataMap.showBoothRepsOnly"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entityEdit.dataMap.showBoothRepsOnly ? 'Active' : 'Inactive'
									"
									class="mt-0"
									dense
									hint="Attendees only see booth reps online (for booth chat)"
									persistent-hint
								></v-switch>
							</v-col>
							<v-col cols="12" sm="6">
								<v-switch
									v-model="entityEdit.dataMap.fitToHeight"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entityEdit.dataMap.fitToHeight ? 'Enabled' : 'Disabled'
									"
									class="mt-0"
									dense
									hint="Adjust the background fit to the screen"
									persistent-hint
								></v-switch>
							</v-col>
							<v-col cols="12" sm="6">
								<v-switch
									v-model="entityEdit.layerMode"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entityEdit.layerMode == true ? 'Enabled' : 'Disabled'
									"
									class="mt-0"
									dense
									hint="Enable layer mode"
									persistent-hint
								></v-switch>
							</v-col>
							<v-col cols="12" sm="6" v-if="this.isUserAdmin == true">
								<v-switch
									v-model="entityEdit.template"
									inset
									prepend-icon="mdi-list-status"
									:label="
										entityEdit.template == true ? 'Active' : 'Inactive'
									"
									class="mt-0"
									dense
									hint="Event Template"
									persistent-hint
								></v-switch>
							</v-col>
							<v-col
								cols="12"
								sm="2"
								v-if="entityEdit.template"
							>
								<v-select
									v-model="imageTemplateType"
									:items="['Upload', 'URL']"
									label="Image Template Type"
									hint="Choose how to fill the Image Template"
									:prepend-icon="
										imageTemplateType === 'Upload'
											? 'mdi-upload'
											: 'mdi-file-cloud'
									"
									persistent-hint
									dense
								></v-select>
							</v-col>
							<v-col
								cols="12"
								sm="4"
								v-if="entityEdit.template"
							>
								<v-file-input
									v-if="imageTemplateType === 'Upload'"
									v-model="attachment4"
									accept="image/png, image/jpeg, image/jpg"
									label="Select your Image Template"
									hint="It’s recommended to use image with resolution approximately 400 x 60 pixels."
									persistent-hint
									prepend-icon="mdi-image"
									:show-size="1000"
									dense
								>
									<template
										v-slot:selection="{ text }"
										:default="entityEdit.imageTemplate"
									>
										<v-chip
											color="primary"
											dark
											label
											small
											>{{ text }}</v-chip
										>
									</template>
								</v-file-input>
								<v-text-field
									v-else
									v-model="entityEdit.imageTemplate"
									prepend-icon="mdi-image"
									label="Select your image template"
									placeholder="Image Template Url"
									hint="It’s recommended to use image with resolution approximately 400 x 60 pixels."
									persistent-hint
									dense
								>
								</v-text-field>
							</v-col>
						</v-row>
						<div>
							Error Notification :
							<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="initTextEditor" v-model="entityEdit.errorMsg"/>
						</div>
						<div class="d-flex justify-end">
							<v-btn
								:disabled="!valid"
								type="submit"
								color="primary darken-1"
								depressed
								tile
								>Save</v-btn
							>
						</div>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="dialogMenu"
			persistent
			no-click-animation
			fullscreen
			transition="dialog-bottom-transition"
		>
			<v-card tile>
				<v-card-title class="headline">
					Menu Navigation
					<v-spacer></v-spacer>
					<v-btn icon @click="closeMenu()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-form
						ref="formMenu"
						v-model="valid"
						@submit.prevent="editExperienceMenu()"
					>
						<v-row class="mx-0">
							<v-btn class="primary my-4" @click="addMenuItem()">
								Add New Menu
								<v-icon>mdi-plus</v-icon>
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn class="primary my-4" type="submit">
								Save
								<v-icon>mdi-content-save-outline</v-icon>
							</v-btn>
						</v-row>
						<v-row
							class="d-none d-sm-flex justify-center"
							style="
								background-color: black;
								color: white;
								margin-left: 0;
								margin-right: 0;
							"
						>
							<div
								v-for="(
									menu, indexL1
								) in entityMenu.menuDataList"
								:key="indexL1"
							>
								<template v-if="menu.childList && menu.childList.length > 0">
									<v-menu
										ref="root"
										right
										bottom
										offset-y
										rounded="0 b-lg"
										dark
									>
										<template
											v-slot:activator="{
												on,
												attrs,
												value,
											}"
										>
											<v-btn
												text
												v-bind="attrs"
												v-on="on"
												dark
												tile
											>
												{{ menu.name }}
												<v-icon right dark>{{
													value
														? "mdi-chevron-up"
														: "mdi-chevron-down"
												}}</v-icon>
											</v-btn>
										</template>

										<v-list
											v-if="menu.childList && menu.childList.length > 0"
											color="black"
											dense
										>
											<div
												v-for="(
													subMenu, indexL2
												) in menu.childList"
												:key="indexL2"
											>
												<v-menu
													v-if="subMenu.childList && subMenu.childList.length > 0"
													open-on-hover
													offset-x
													rounded="l-0 r-lg"
													dark
												>
													<template
														v-slot:activator="{
															on,
															attrs,
														}"
													>
														<v-list
															color="black"
															style="
																padding: 0 !important;
															"
															dense
														>
															<v-hover
																v-slot:default="{
																	hover,
																}"
															>
																<v-list-item
																	v-bind="
																		attrs
																	"
																	v-on="on"
																	dense
																>
																	<v-list-item-icon>
																		<v-img
																			v-if="
																				hover
																			"
																			contain
																			aspect-ratio="1"
																			:src="
																				$root.asset(
																					subMenu.iconHover
																				)
																			"
																		></v-img>
																		<v-img
																			v-else
																			contain
																			aspect-ratio="1"
																			:src="
																				$root.asset(
																					subMenu.icon
																				)
																			"
																		></v-img>
																	</v-list-item-icon>
																	<v-list-item-content>
																		<v-list-item-title
																			v-if="
																				hover
																			"
																			style="
																				color: #eb6e1f;
																			"
																			>{{
																				subMenu.name
																			}}</v-list-item-title
																		>
																		<v-list-item-title
																			v-else
																			>{{
																				subMenu.name
																			}}</v-list-item-title
																		>
																	</v-list-item-content>
																	<v-list-item-icon>
																		<v-btn
																			v-if="
																				$store
																					.state
																					.principal
																					.type ===
																				'Exhibition'
																			"
																			icon
																			x-small
																			@click="
																				addMenuItem(
																					subMenu
																				)
																			"
																		>
																			<v-icon
																				>mdi-plus</v-icon
																			>
																		</v-btn>
																		<v-btn
																			icon
																			x-small
																			@click="
																				editMenuItem(
																					subMenu
																				)
																			"
																		>
																			<v-icon
																				>mdi-pencil</v-icon
																			>
																		</v-btn>
																		<v-btn icon x-small @click.stop="movePosition(menu.childList, indexL2, indexL2 - 1)">
																			<v-icon color="white">mdi-arrow-up</v-icon>
																		</v-btn>
																		<v-btn icon x-small @click.stop="movePosition(menu.childList, indexL2, indexL2 + 1)">
																			<v-icon color="white">mdi-arrow-down</v-icon>
																		</v-btn>
																		<v-btn
																			icon
																			x-small
																			@click.stop="
																				deleteMenuItem(
																					subMenu.id,
																					menu.childList
																				)
																			"
																		>
																			<v-icon
																				>mdi-delete</v-icon
																			>
																		</v-btn>
																	</v-list-item-icon>
																</v-list-item>
															</v-hover>
														</v-list>
													</template>
													<v-list
														color="black"
														style="
															padding: 0 !important;
														"
														dense
													>
														<v-list-item
															v-for="(
																item, indexL3
															) in subMenu.childList"
															:key="indexL3"
															link
														>
															<v-list-item-icon>
																<v-img
																	contain
																	aspect-ratio="1"
																	:src="
																		$root.asset(
																			item.icon
																		)
																	"
																></v-img>
															</v-list-item-icon>

															<v-list-item-content>
																<v-list-item-title
																	>{{
																		item.name
																	}}</v-list-item-title
																>
															</v-list-item-content>

															<v-list-item-icon>
																<v-btn
																	icon
																	x-small
																	@click="
																		editMenuItem(
																			item
																		)
																	"
																>
																	<v-icon
																		>mdi-pencil</v-icon
																	>
																</v-btn>
																<v-btn icon x-small @click.stop="movePosition(subMenu.childList, indexL3, indexL3 - 1)">
																	<v-icon color="white">mdi-arrow-up</v-icon>
																</v-btn>
																<v-btn icon x-small @click.stop="movePosition(subMenu.childList, indexL3, indexL3 + 1)">
																	<v-icon color="white">mdi-arrow-down</v-icon>
																</v-btn>
																<v-btn
																	icon
																	x-small
																	@click.stop="
																		deleteMenuItem(
																			item.id,
																			subMenu.childList
																		)
																	"
																>
																	<v-icon
																		>mdi-delete</v-icon
																	>
																</v-btn>
															</v-list-item-icon>
														</v-list-item>
													</v-list>
												</v-menu>

												<v-hover
													v-else
													v-slot:default="{ hover }"
												>
													<v-list-item link>
														<v-list-item-icon>
															<v-img
																v-if="hover"
																contain
																aspect-ratio="1"
																:src="
																	$root.asset(
																		subMenu.iconHover
																	)
																"
															></v-img>
															<v-img
																v-else
																contain
																aspect-ratio="1"
																:src="
																	$root.asset(
																		subMenu.icon
																	)
																"
															></v-img>
														</v-list-item-icon>

														<v-list-item-content>
															<v-list-item-title
																v-if="hover"
																style="
																	color: #eb6e1f;
																"
																>{{
																	subMenu.name
																}}</v-list-item-title
															>
															<v-list-item-title
																v-else
																>{{
																	subMenu.name
																}}</v-list-item-title
															>
														</v-list-item-content>

														<v-list-item-icon>
															<v-btn
																v-if="
																	$store.state
																		.principal
																		.type ===
																	'Exhibition'
																"
																icon
																x-small
																@click="
																	addMenuItem(
																		subMenu
																	)
																"
															>
																<v-icon
																	>mdi-plus</v-icon
																>
															</v-btn>
															<v-btn
																icon
																x-small
																@click="
																	editMenuItem(
																		subMenu
																	)
																"
															>
																<v-icon
																	>mdi-pencil</v-icon
																>
															</v-btn>
															<v-btn icon x-small @click.stop="movePosition(menu.childList, indexL2, indexL2 - 1)">
																<v-icon color="white">mdi-arrow-up</v-icon>
															</v-btn>
															<v-btn icon x-small @click.stop="movePosition(menu.childList, indexL2, indexL2 + 1)">
																<v-icon color="white">mdi-arrow-down</v-icon>
															</v-btn>
															<v-btn
																icon
																x-small
																@click.stop="
																	deleteMenuItem(
																		subMenu.id,
																		menu.childList
																	)
																"
															>
																<v-icon
																	>mdi-delete</v-icon
																>
															</v-btn>
														</v-list-item-icon>
													</v-list-item>
												</v-hover>
											</div>
										</v-list>
									</v-menu>
									<v-btn
										icon
										x-small
										@click="addMenuItem(menu)"
									>
										<v-icon color="white">mdi-plus</v-icon>
									</v-btn>
									<v-btn
										icon
										x-small
										@click="editMenuItem(menu)"
									>
										<v-icon color="white"
											>mdi-pencil</v-icon
										>
									</v-btn>
									<v-btn icon x-small @click.stop="movePosition(entityMenu.menuDataList, indexL1, indexL1 - 1)">
										<v-icon color="white">mdi-arrow-left</v-icon>
									</v-btn>
									<v-btn icon x-small @click.stop="movePosition(entityMenu.menuDataList, indexL1, indexL1 + 1)">
										<v-icon color="white">mdi-arrow-right</v-icon>
									</v-btn>
									<v-btn
										icon
										x-small
										@click.stop="
											deleteMenuItem(menu.id, null, true)
										"
									>
										<v-icon color="white"
											>mdi-delete</v-icon
										>
									</v-btn>
								</template>
								<v-btn
									v-else
									class="hover-underline"
									tile
									text
									dark
								>
									{{ menu.name }}
									<v-btn
										icon
										x-small
										@click="addMenuItem(menu)"
									>
										<v-icon>mdi-plus</v-icon>
									</v-btn>
									<v-btn
										icon
										x-small
										@click="editMenuItem(menu)"
									>
										<v-icon>mdi-pencil</v-icon>
									</v-btn>
									<v-btn icon x-small @click.stop="movePosition(entityMenu.menuDataList, indexL1, indexL1 - 1)">
										<v-icon color="white">mdi-arrow-left</v-icon>
									</v-btn>
									<v-btn icon x-small @click.stop="movePosition(entityMenu.menuDataList, indexL1, indexL1 + 1)">
										<v-icon color="white">mdi-arrow-right</v-icon>
									</v-btn>
									<v-btn
										icon
										x-small
										@click.stop="
											deleteMenuItem(menu.id, null, true)
										"
									>
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</v-btn>
							</div>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogMenuItem"
			persistent
			no-click-animation
			transition="dialog-bottom-transition"
			width="500"
		>
			<v-card>
				<v-card-text class="pt-6">
					<v-form v-model="valid" ref="menuForm">
						<v-text-field
							v-model="menuItem.name"
							label="Name"
							:rules="[(v) => !!v || 'Name is required']"
							dense
							required
						></v-text-field>
						<v-select
							v-if="$store.state.principal.type === 'Exhibition'"
							v-model="menuItem.linkType"
							:items="['URL', 'Room', 'Leaderboard', 'Networking Lounge']"
							label="Link Type"
						></v-select>
						<v-select
							v-else
							v-model="menuItem.linkType"
							:items="['URL', 'Room']"
							label="Link Type"
						></v-select>
						<v-text-field
							v-if="menuItem.linkType === 'URL'"
							v-model="menuItem.linkTo"
							label="Link To URL"
							:rules="[
								(v) => !!v || 'Link To URL is required',
								(v) =>
									/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(
										v
									) || 'URL must be valid',
							]"
							dense
							required
						></v-text-field>
						<v-select
							v-else-if="menuItem.linkType === 'Room'"
							v-model="menuItem.linkTo"
							:items="rooms"
							label="Link To Room"
							item-text="name"
							item-value="slug"
							:rules="[(v) => !!v || 'Link To Room is required']"
							dense
							required
						></v-select>
						<v-select
							v-if="menuItem.linkType != 'Networking Lounge'"
							v-model="menuItem.icon"
							:items="icons"
							item-text="name"
							item-value="icon"
							label="Icon"
							@input="
								menuItem.iconHover = menuItem.icon
									? menuItem.icon.replace('.png', '.Alt.png')
									: undefined
							"
						>
							<template v-slot:selection="{ item }">
								<v-list-item-icon>
									<v-img
										contain
										height="16"
										aspect-ratio="1"
										:src="$root.asset(item.iconHover)"
									></v-img>
								</v-list-item-icon>
								<v-list-item-content>{{
									item.name
								}}</v-list-item-content>
							</template>
							<template v-slot:item="{ item }">
								<v-list-item-icon>
									<v-img
										contain
										height="16"
										aspect-ratio="1"
										:src="$root.asset(item.iconHover)"
									></v-img>
								</v-list-item-icon>
								<v-list-item-content>{{
									item.name
								}}</v-list-item-content>
							</template>
						</v-select>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<template v-if="menuItem.id">
						<v-btn text @click="dialogMenuItem = false"
							>Cancel</v-btn
						>
						<v-btn
							:disabled="!valid"
							text
							@click="dialogMenuItem = false"
							>Save</v-btn
						>
					</template>
					<template v-else>
						<v-btn
							text
							@click="
								(dialogMenuItem = false), $refs.menuForm.reset()
							"
							>Cancel</v-btn
						>
						<v-btn
							:disabled="!valid"
							color="primary"
							text
							@click="addChild(menu)"
							>Add</v-btn
						>
					</template>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogDuplicate.show" max-width="500">
			<v-card>
				<v-card-title>Select Destination Tenant</v-card-title>

				<v-form class="px-5">
					<v-select v-model="dialogDuplicate.selected" :items="duplicateList" item-text="name" label="Select Tenant" solo return-object> </v-select>
				</v-form>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogDuplicate.show = false">Cancel</v-btn>
					<v-btn color="primary" @click="duplicateExperienceToTenant(dialogDuplicate.selected)">Duplicate</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";

export default {
	props: ["mode"],
	components: {
		editor: Editor,
	},
	data() {
		return {
			loaded: false,
			today:
				new Date().getFullYear() +
				"-" +
				(new Date().getMonth() + 1) +
				"-" +
				new Date().getDate(),
			valid: true,
			dialogAdd: false,
			dialogEdit: false,
			dialogMenu: false,
			dialogMenuItem: false,
			dialogDuplicate: {
				show: false,
				experienceId: null,
				selected: null
			},
			dialogSelectAddMode: {
				show: false,
				addMode: [
					"New",
					"From Template"
				],
				selected: "New"
			},
			dialogAddByTemplate: {
				show: false,
				selected: null,
				search: ""
			},
			entity: {
				status: false,
				dataMap: {
                    twitterId: null,
                    ongoing: false,
                    showBoothRepsOnly: false,
                    showHeader: true,
                    useMobileNavigation: false
                },
				transitMap: { startDate: "", endDate: "" },
				errorMsg: "",
			},
			entityEdit: {
				status: false,
				dataMap: {
                    twitterId: null,
                    ongoing: false,
                    showBoothRepsOnly: false,
                    showHeader: true,
                    useMobileNavigation: false
                },
				transitMap: { startDate: "", endDate: "" },
				errorMsg: "",
			},
			entityMenu: {
				status: false,
				menuDataList: [],
				dataMap: {
                    twitterId: null,
                    ongoing: false,
                    showBoothRepsOnly: false,
                    showHeader: true,
                    useMobileNavigation: false
                },
				transitMap: {},
				errorMsg: "",
			},
			entityList: [],
			experienceTemplateList: [],
			duplicateList: null,
			isUserAdmin: false,
			isShowAddStartDate: false,
			isShowAddEndDate: false,
			isShowEditStartDate: false,
			isShowEditEndDate: false,
			timeZones: [],
			attachment1: null,
			attachment2: null,
			attachment3: null,
			attachment4: null,
			menu: null,
			menuItem: { childList: [] },
			rooms: [],
			hover: false,
			icons: [
				{
					name: "Auditorium",
					icon:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Auditorium.Icon.png",
					iconHover:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Auditorium.Icon.Alt.png",
				},
				{
					name: "Boardroom",
					icon:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Boardroom.Icon.png",
					iconHover:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Boardroom.Icon.Alt.png",
				},
				{
					name: "Exhibit",
					icon:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Exhibit.Icon.png",
					iconHover:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Exhibit.Icon.Alt.png",
				},
				{
					name: "Gala",
					icon:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Gala.Icon.png",
					iconHover:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Gala.Icon.Alt.png",
				},
				{
					name: "Info Center",
					icon:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Info.Center.Icon.png",
					iconHover:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Info.Center.Icon.Alt.png",
				},
				{
					name: "Leaderboard",
					icon:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Leaderboard.Icon.png",
					iconHover:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Leaderboard.Icon.Alt.png",
				},
				{
					name: "Lobby",
					icon:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Lobby.Icon.png",
					iconHover:
						"https://v-unite.s3-us-west-1.amazonaws.com/common/icon/Lobby.Icon.Alt.png",
				},
			],
			baseLocation: axios.defaults.baseURL,
			host: location.host,
			logoType: "Upload",
			bannerType: "Upload",
			boothBackgroundType: "Upload",
			imageTemplateType: "Upload",
			hour: "00",
			minute: "00",
			second: "00",
			boothBackgroundList: [],
			selectedBoothBackground: null,
			boothBackgroundAll: [],
			boothBackgroundTagFilter: [],
			boothBackgroundTagList: [],
			showBoothBackgroundLibrary: false,
			selectedBoothBackgroundImage: null,
			initTextEditor: {
				height: 300,
				menubar: false,
				plugins: ["advlist autolink lists link image charmap print preview anchor", "searchreplace visualblocks code fullscreen", "insertdatetime media table paste code help wordcount"],
				toolbar1: "undo redo | formatselect",
				toolbar2: "fontselect | fontsizeselect",
				toolbar3: "alignleft aligncenter alignright | bold italic underline | forecolor backcolor | link",
				fontsize_formats: '1pt 2pt 3pt 4pt 5pt 6pt 7pt 8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt',
			},
		};
	},
	mounted() {
		this.listExperience();
		this.listExperienceTemplate();
		this.listTimeZone();
		this.listBoothBackground();
		this.listAdminContent();
		this.dialogAddByTemplate.show = this.mode === 'template';

		this.$root.appendTinyMCECustomFonts(this.initTextEditor);
	},
	computed: {
		filterExperienceTemplateByName() {
			return this.experienceTemplateList.filter(experience => {
				return experience.name.toLowerCase().includes(this.dialogAddByTemplate.search);
			});
		}
	},
	methods: {
		listBoothBackground() {
			axios
				.post("/system/boothbackgroundlibrary/membership/list", {
					tenantPlanId: this.$store.state.principal.tenantPlanId
				})
				.then(response => {
					this.boothBackgroundList = response.data;
					this.boothBackgroundAll = this.boothBackgroundList;
					this.listBoothBackgroundTag();
				});
		},
		listBoothBackgroundTag() {
			axios.get("/system/boothbackgroundlibrary/tag/list").then(response => {
				this.boothBackgroundTagList = response.data;
			});
		},
		selectBoothBackground(item) {
			this.selectedBoothBackground = item.id;
		},
		filterBoothBackground() {
			axios.post("/system/boothbackgroundlibrary/filter",{
				planFilter : [],
				tagFilter : this.boothBackgroundTagFilter,
				tenantPlanId: this.$store.state.principal.tenantPlanId
			}).then((response) => {
				this.boothBackgroundList = response.data;
			});
		},
		resetBoothBackground(){
			this.boothBackgroundPlanFilter = [];
			this.boothBackgroundTagFilter = [];
			this.boothBackgroundList = this.boothBackgroundAll;
		},
		listTimeZone() {
			axios
				.get("/system/enumeration/timezone/list")
				.then((response) => {
					this.timeZones = response.data;
				})
				.catch(() => {});
		},
		listExperience() {
			axios
				.get("/system/experience/list")
				.then((response) => {
					this.entityList = response.data;
				})
				.catch(() => {});
		},
		listExperienceTemplate() {
			axios
				.get("/system/experience/template/list")
				.then((response) => {
					this.experienceTemplateList = response.data;
				})
				.catch(() => {});
		},
		listStructure(experienceId) {
			axios
				.get("/system/structure/list?experienceId=" + experienceId)
				.then((response) => {
					this.rooms = response.data;
					this.rooms.sort((a, b) => (a.name > b.name ? 1 : -1));
				});
		},
		listAdminContent() {
			axios
				.get("/system/administratoremail/isAdmin")
				.then((response) => {
					this.isUserAdmin = response.data == true ? true : false;
					if(this.isUserAdmin){
						this.listDuplicateTenant();
					}
				})
				.catch(() => {});
		},
		listDuplicateTenant() {
			axios
				.get("/system/administratoremail/tenantList")
				.then((response) => {
					let tenantList = response.data;
					let tenantId = this.$store.state.principal.tenantId;
					if(tenantList.length > 0) {
						for(let tenant of tenantList){
							if(tenantId === tenant.id){
							tenant.name = tenant.name + " (current)";
							this.dialogDuplicate.selected = tenant;
							break;
							}
						}
					}
					this.duplicateList = tenantList;
				})
				.catch(() => {});
		},
		showAdd() {
			this.dialogSelectAddMode.show = false;
			this.entity = {
				status: true,
				dataMap: {
                    twitterId: null,
                    ongoing: false,
                    showBoothRepsOnly: false ,
                    showHeader: true,
                    useMobileNavigation: false
                },
				transitMap: { startDate: "", endDate: "" },
				layerMode: true
			};
			this.attachment1 = null;
			this.attachment2 = null;
			this.attachment3 = null;
			this.attachment4 = null;
			this.dialogAdd = true;
			if (this.$refs.formAdd) {
				this.$refs.formAdd.resetValidation();
			}
		},
		closeAdd() {
			this.dialogAdd = false;
			this.selectedBoothBackground = null;
			this.selectedBoothBackgroundImage = null;
			this.$refs.formAdd.resetValidation();
		},
		showAddByTemplate() {
			this.dialogAddByTemplate.show = true;
			this.dialogSelectAddMode.show = false;
		},
		closeAddByTemplate() {
			this.dialogAddByTemplate.show = false;
			this.dialogAddByTemplate.search = '';
		},
		changeBoothBackground(){
			this.showBoothBackgroundLibrary = true;
		},
		showEdit(item) {
			this.entityEdit = {...item};

			if (this.entityEdit.logo) {
				this.logoType = "URL";
			} else {
				this.logoType = "Upload";
			}
			if (this.entityEdit.banner) {
				this.bannerType = "URL";
			} else {
				this.bannerType = "Upload";
			}
			if (this.entityEdit.dataMap.boothBackgroundId) {
				this.selectedBoothBackground = this.entityEdit.dataMap.boothBackgroundId;
				let filteredBoothBackground = this.boothBackgroundAll.filter(x => x.id == this.selectedBoothBackground);

				if(filteredBoothBackground.length > 0){
					this.selectedBoothBackgroundImage = filteredBoothBackground[0].background;
				}
				this.showBoothBackgroundLibrary = false;
			}
			if (this.entityEdit.dataMap.showHeader == null) {
				this.entityEdit.dataMap.showHeader = true;
			}

            if (this.entityEdit.dataMap.useMobileNavigation == 'undefined') {
				this.entityEdit.dataMap.useMobileNavigation = false;
			}

			this.dialogEdit = true;
			if (this.$refs.formEdit) {
				this.$refs.formEdit.resetValidation();
				this.$router.go();
			}
		},
		closeEdit() {
			this.dialogEdit = false;
			this.selectedBoothBackground = null;
			this.selectedBoothBackgroundImage = null;
			this.$refs.formEdit.resetValidation();
			this.$router.go();
		},
		showMenu(item) {
			this.entityMenu = item;
			if (!this.entityMenu.menuDataList) {
				this.entityMenu.menuDataList = [];
			}
			this.listStructure(item.id);
			this.dialogMenu = true;
		},
		closeMenu() {
			this.listExperience();
			this.dialogMenu = false;
		},
		addMenuItem(item) {
			this.menuItem = { childList: [] };
			if (item) {
				this.menu = item;
			}
			this.dialogMenuItem = true;
			if (this.$refs.menuForm) {
				this.$refs.menuForm.resetValidation();
			}
			if (this.$refs.root) {
				for (let i = 0; i < this.$refs.root.length; i++) {
					this.$refs.root[i].isActive = false;
				}
			}
		},
		editMenuItem(item) {
			if (item) {
				this.menuItem = item;
			}
			this.dialogMenuItem = true;
			if (this.$refs.menuForm) {
				this.$refs.menuForm.resetValidation();
			}
			for (let i = 0; i < this.$refs.root.length; i++) {
				this.$refs.root[i].isActive = false;
			}
		},
		closeMenuItem() {
			this.menu = null;
			this.dialogMenuItem = false;
			this.$refs.formMenu.resetValidation();
		},
		deleteExperience(id) {
			if (confirm("Are you sure you want to delete?")) {
				axios
					.post("/system/experience/delete", { id })
					.then(() => {
						this.listExperience();
						this.listExperienceTemplate();
					})
					.catch(() => {});
			}
		},
		addExperience() {
			let formData = new FormData();
			this.entity.dataMap.boothBackgroundId = this.selectedBoothBackground;

			formData.append("entity", JSON.stringify(this.entity));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
			}
			if (this.attachment4) {
				formData.append("attachment4", this.attachment4);
			}
			axios
				.post("/system/experience/add", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(() => {
					this.closeAdd();
					this.listExperience();
					this.listExperienceTemplate();
				})
				.catch(() => {});
		},
		editExperience() {
			let formData = new FormData();
			this.entityEdit.dataMap.boothBackgroundId = this.selectedBoothBackground;
			formData.append("entity", JSON.stringify(this.entityEdit));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
			}
			if (this.attachment4) {
				formData.append("attachment4", this.attachment4);
			}

			axios
				.post("/system/experience/edit", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(() => {
					this.closeEdit();
					this.listExperience();
					this.listExperienceTemplate();
					this.entityEdit.errorMsg = "";
				})
				.catch(() => {});
		},
		editExperienceMenu() {
			let formData = new FormData();

			formData.append("entity", JSON.stringify(this.entityMenu));

			axios
				.post("/system/experience/edit", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(() => {
					this.closeMenu();
				})
				.catch(() => {});
		},
		addChild(item) {
			const id = Math.random().toString(36).substr(2, 9);
			const name = this.menuItem.name;
			const linkType = this.menuItem.linkType;
			const linkTo = this.menuItem.linkTo;
			const icon = this.menuItem.icon;
			const iconHover = this.menuItem.icon
				? this.menuItem.icon.replace(".png", ".Alt.png")
				: undefined;

			if (item != null) {
				if (!item.childList) {
					this.$set(item, "childList", []);
				}

				item.childList.push({
					id,
					name,
					linkType,
					linkTo,
					icon,
					iconHover,
				});
			} else {
				this.entityMenu.menuDataList.push({
					id,
					name,
					linkType,
					linkTo,
					icon,
					iconHover,
				});
			}
			this.menu = null;
			this.dialogMenuItem = false;
			this.$refs.menuForm.reset();
		},
		deleteMenuItem(id, items = null, root = false) {
			if (!items) {
				items = this.entityMenu.menuDataList;
			}

			let list = items;
			for (let i in items) {
				if (list[i].id === id) {
					list.splice(i, 1);
					break;
				}
				if (
					list[i].childList != undefined &&
					list[i].childList != null &&
					list[i].childList.length > 0 &&
					!root
				) {
					this.deleteMenuItem(id, list[i].childList);
				}
			}
		},
		navigateTo(experience) {
			this.$root.selectedExperience = experience;
			if (this.$store.state.principal.type === "Exhibition") {
				this.$router.push(
					"/tenant/experience/" + experience.id + "/dashboard"
				);
			} else {
				this.$router.push(
					"/tenant/experience/" + experience.id + "/structure"
				);
			}
		},
		resetTime() {
			this.hour = "00";
			this.minute = "00";
			this.second = "00";
		},
		changeDatetime: function (dateTime) {
			if (dateTime === "") {
				return (
					this.today +
					" " +
					this.hour +
					":" +
					this.minute +
					":" +
					this.second
				);
			} else {
				return (
					dateTime.substr(0, 10) +
					" " +
					this.hour +
					":" +
					this.minute +
					":" +
					this.second
				);
			}
		},
		duplicateExperienceTemplate(id) {
			if (confirm("Are you sure you want to add this template?"))
				axios
					.post("/system/experience/duplicate", {id: id})
					.then(() => {
						this.listExperience();
						this.closeAddByTemplate();
					});
		},
		duplicateExperience(id) {
			if(this.isUserAdmin == true){
				this.dialogDuplicate.show = true;
				this.dialogDuplicate.experienceId = id;
			} else {
				if (confirm("Are you sure you want to duplicate this Experience?"))
				axios
					.post("/system/experience/duplicate", {id: id})
					.then(() => {
						this.listExperience();
					});
			}
		},
		duplicateExperienceToTenant(tenant) {
			if  (confirm("Are you sure you want to duplicate this Experience to ["+tenant.name+"]?")){
				axios
					.post("/system/experience/duplicate", {id: this.dialogDuplicate.experienceId, tenantId: tenant.id})
					.then(() => {
						this.dialogDuplicate.experienceId = null;
						this.dialogDuplicate.show = false;
						this.listExperience();

						alert("Experience duplicated to Tenant ["+tenant.name+"]");
					});
			}
		},
		movePosition(arr, oldIndex, newIndex) {
			if (newIndex > -1 && newIndex < arr.length) {
				const temp0 = arr[oldIndex];
				const temp1 = arr[newIndex];
				this.$set(arr, oldIndex, temp1);
				this.$set(arr, newIndex, temp0);
			}
		},
		parseHtml(desc) {
			if (desc) {
				desc = desc.replace(/\n/g, '</p><p style="text-align: center">');
				return '<p style="text-align: center">' + desc + "</p>";
			}
			return desc;
		},
	},
};
</script>
